import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener("turbo:submit-end", this.updateUrl);
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.updateUrl);
  }

  updateUrl = (event) => {
    if (!event.detail.success) return;

    const url = new URL(this.element.action);
    const formData = new FormData(this.element);

    url.search = "";
    formData.forEach((value, key) => {
      if (value) url.searchParams.set(key, value);
    });

    history.replaceState({}, "", url);
  };
}
